module.exports = __webpack_public_path__ + "img/angle_105.dda784fa.jpg";